import { createRouter, createWebHistory } from "@ionic/vue-router"

// routes
const routes = [
	{ path: "", redirect: "/login" },
	{ path: "/login", name: "login", component: () => import("../pages/LoginPage.vue") },
	{ path: "/forceupdate", name: "forceUpdate", component: () => import("../ForceUpdate.vue") },
	{ path: "/maintenance", name: "maintenance", component: () => import("../Maintenance.vue") },
	{
		path: "/tab",
		component: () => import("../pages/TabsWrapper.vue"),
		children: [
			{ path: "map", component: () => import("../pages/MapPage.vue") },
			{
				path: "tour",
				component: () => import("../pages/Tour/TourSplitPanePage.vue"),
				children: [
					{ path: "", component: () => import("../pages/Tour/IndexPage.vue") },
					{ path: "create", component: () => import("../pages/Tour/CreatePage.vue") },
					{ path: ":id/show", component: () => import("../pages/Tour/DetailPage.vue") },
					{ path: ":id", component: () => import("../pages/Tour/EditPage.vue") },
				],
			},
			{
				path: "places",
				component: () => import("../pages/Places/PlacesSplitPanePage.vue"),
				children: [
					{ path: "", component: () => import("../pages/Places/IndexPage.vue") },
					{ path: "markercategory/orphaned", component: () => import("../pages/Places/Marker/OrphanedListPage.vue") },
					{ path: "markercategory/:id/marker", component: () => import("../pages/Places/Marker/ListPage.vue") },
				],
			},

			{
				path: "share",
				component: () => import("../pages/Share/ShareSplitPanePage.vue"),
				children: [
					{ path: "", component: () => import("../pages/Share/IndexPage.vue") },
					{ path: "create", component: () => import("../pages/Share/CreatePage.vue") },
					{ path: ":id", component: () => import("../pages/Share/EditPage.vue") },
				],
			},

			{ path: "alarm", component: () => import("../pages/Alarm/StatusPage.vue") },
			{ path: "settings", component: () => import("../pages/Settings/SettingsPage.vue") },
			{ path: "settings/account", component: () => import("../pages/Settings/AccountPage.vue") },
			{ path: "settings/display", component: () => import("../pages/Settings/DisplayPage.vue") },
			{ path: "settings/photos", component: () => import("../pages/Settings/PhotosPage.vue") },
			{ path: "settings/notifications", component: () => import("../pages/Settings/NotificationsPage.vue") },
			{ path: "settings/data", component: () => import("../pages/Settings/DataPage.vue") },
			{ path: "settings/app", component: () => import("../pages/Settings/AppInfoPage.vue") },
			{ path: "settings/legal", component: () => import("../pages/Settings/LegalPage.vue") },
			{ path: "settings/legal/licenses", component: () => import("../pages/Settings/Legal/LicensesPage.vue") },
			{ path: "settings/tracker", component: () => import("../pages/Settings/TrackerPage.vue") },
			{ path: "settings/tracker/:id", component: () => import("../pages/Settings/Tracker/EditPage.vue") },
			{ path: "settings/tracker/:id/stats", component: () => import("../pages/Settings/Tracker/StatisticsPage.vue") },
		],
	},

	// Debugging routes, which can be accessed without login
	{ path: "/debug/database", component: () => import("../pages/Debug/DatabasePage.vue") },
	{ path: "/debug/photo", component: () => import("../pages/Debug/PhotoLibraryPage.vue") },
	{ path: "/debug/ui", component: () => import("../pages/Debug/UiPage.vue") },
]

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes,
})

export default router
